import GroupDataOverview from './GroupDataOverview'
import enhance from './GroupDataOverview.enhancer'

export default enhance(GroupDataOverview)

export const groupColumns = [
  {
    width: 75, field: 'selectable', selectable: true, format: 'locate',
  },
  {
    width: 160, label: 'Group Name', field: 'groupName', format: 'groupName'
  },
  {
    width: 160, label: 'Traps', field: 'totalTraps', align: 'flex-end',
  },
  {
    width: 160, 
    align: 'flex-end',
    label: 'Traps Synced', 
    field: 'totalTrapsSynced',
    format: 'trapsSyncedPercent',
    helpText: 'Percentage of traps within a group that have been synced and had data collected in the last month'
  },
  {
    width: 160, label: 'Kills', field: 'totalKills', align: 'flex-end',
  },
  {
    width: 160, 
    align: 'flex-end',
    format: 'percentage',
    field: 'operatingRate',
    label: 'Operating rate',
    helpText: 'Percentage of time traps had CO2 and Paste to perform kills'
  }
]



// WEBPACK FOOTER //
// ./src/containers/groups/GroupDataOverview/index.js